export const DetalleQuienReserva = (props) => {
    return (
        <div className="bg-white border rounded-md">
            <div className=" border-gray-200 p-0">
                <div className="sm:divide-y sm:divide-gray-200 ">
                    <div className="py-2 grid grid-cols-3 gap-2 px-3 hover:bg-gray-100">
                        <div className="text-sm font-medium text-gray-500">
                            Reservo
                        </div>
                        <div className="text-sm text-gray-900 sm:col-span-2">
                            {props?.registro?.usuario_reservacion?.name}
                        </div>
                    </div>
                    <div className="py-2 grid grid-cols-3 gap-2 px-3 hover:bg-gray-100">
                        <div className="text-sm font-medium text-gray-500">
                            Confirmo
                        </div>
                        <div className="text-sm text-gray-900 sm:col-span-2">
                        {props?.registro?.usuario_confirmacion?.name}
                        </div>
                    </div>
                    <div className="py-2 grid grid-cols-3 gap-2 px-3 hover:bg-gray-100">
                        <div className="text-sm font-medium text-gray-500">
                            Ocupo
                        </div>
                        <div className="text-sm text-gray-900 sm:col-span-2">
                        {props?.registro?.usuario_ingreso?.name}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
